export const defaultSettings = {
  videoUrl: '',
  altText: '',
  fullWidth: false,
  align: 'center',
  imageUrl: '',
  width: '',
  // Intrinsic thumbnail dimensions, captured when the thumbnail is added/changed,
  // used to reserve the rendered box so a blocked image doesn't collapse (FE-1128).
  naturalWidth: null,
  naturalHeight: null,
}
